import styled from '@emotion/styled';

import Image from 'components/global/Image';

import { Breakpoints } from 'utils/const.styles';

export const Header = styled.div`
	display: flex;

	@media ${Breakpoints.mobile} {
		padding: var(--padding-4);
	}
`;
export const RightContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

export const LeftContainer = styled.div`
	margin-right: var(--margin-3);
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-3);
	}
`;
export const Logo = styled(Image)`
	border-radius: 4px;
`;
